module.exports = __webpack_public_path__ + "static/media/icn_upload_form_16.2efc719f.svg";